import projectTabs from '../project-review/projectTabs';
import actionItems from '../project-review/actionItems';
import lessonsLearned from '../project-review/lessonsLearned';
import pieChartVisuals from '../project-review/pieChartVisuals';
import getBodySettings from '../global/page-settings';

export default function () {
    projectTabs();
    actionItems();
    lessonsLearned();
    pieChartVisuals();
}